import React from 'react';

const ConfigContext = React.createContext({
  updateConfig: _ => {},
});

export default ConfigContext;
